import { render, staticRenderFns } from "./wy-auto-qa-ai-evaluation-question-manager-page.vue?vue&type=template&id=83bfd19e&"
import script from "./wy-auto-qa-ai-evaluation-question-manager-page.vue?vue&type=script&lang=js&"
export * from "./wy-auto-qa-ai-evaluation-question-manager-page.vue?vue&type=script&lang=js&"
import style0 from "./wy-auto-qa-ai-evaluation-question-manager-page.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports